import { useState, useEffect, useRef } from "react";
import {FiArrowUp} from "react-icons/fi";
import '../../assets/styles/_scrollToTopBtn.scss';
export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const topRef = useRef(null);

  useEffect(() => {
    const element = topRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0 }
    );

    observer.observe(element);
    return () => observer.unobserve(element);
  }, []);

  // smooth
  const scrollToTop = () => {
    const duration = 800; 
    const start = window.scrollY;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); 

      const ease = 1 - Math.pow(1 - progress, 3); 

      window.scrollTo(0, start * (1 - ease));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  return '';
  return (
    <>
      <div
        ref={topRef}
        style={{ position: "absolute", top: 0, left: 0, width: "1px", height: "1px" }}
      ></div>

      <button
        onClick={scrollToTop}
        className={`scroll-top-btn ${visible ? "visible" : ""}`}
      >
        <FiArrowUp className='text-big-1 animation-icon ' />
      </button>
    </>
  );
}
